import type { MouseEvent, ReactNode} from 'react';
import { useRef } from 'react'
import { CSSTransition } from 'react-transition-group'
import { DRAWER, StyledDrawerContainer, StyledMask } from './style'

interface DrawerProps {
	children: ReactNode
	isOpen: boolean
	onOutsideClick?: () => void
	position?: 'absolute' | 'fixed'
	backgroundColor?: string
	fullHeight: boolean
}

export const Drawer = ({
	children,
	isOpen,
	onOutsideClick = () => {},
	position = 'fixed',
	backgroundColor = 'var(--clear)',
	fullHeight = false
}: DrawerProps) => {
	const drawerRef = useRef(null)
	const TIMEOUT = 700

	const onDrawerClick = (event: MouseEvent) => event.stopPropagation()

	return (
		<CSSTransition unmountOnExit ref={drawerRef} in={isOpen} timeout={0}>
			<StyledMask position={position} onClick={onOutsideClick}>
				<StyledDrawerContainer
					backgroundColor={backgroundColor}
					className={DRAWER}
					timeout={TIMEOUT}
					onClick={onDrawerClick}
					fullHeight={fullHeight}
				>
					{children}
				</StyledDrawerContainer>
			</StyledMask>
		</CSSTransition>
	)
 
}
